import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorIceberg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M22.65 20a.75.75 0 0 1-.75.75H2.5a.75.75 0 0 1 0-1.5h19.4a.75.75 0 0 1 .75.75Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M15.5 3.213a1.15 1.15 0 0 0-2.03 0l-4.129 7.77-1.14-2.106a1 1 0 0 0-1.76 0L2.3 16.524A1 1 0 0 0 3.179 18h8.284c.073 0 .143-.008.21-.022h9.758a1.15 1.15 0 0 0 1.016-1.69L15.501 3.214Zm-3.182 13.265-2.162-3.99.066.035L14.485 4.5l6.364 11.98h-8.531Zm-8.3.022 3.303-6.097 3.302 6.097H4.018Z"
    />
  </svg>
);
export default SvgTwoColorIceberg;
